Vue.component('invitation-form', require('./../components/roommate_ad/detail/invitation-form.vue').default);
Vue.component('saved-messages-modal', require('./../components/roommate_ad/invitation/saved-messages-modal.vue').default);
Vue.component('mobile-invitation-form', require('./../components/roommate_ad/detail/mobile-invitation-form.vue').default);
Vue.component('phone-block', require('./../components/roommate_ad/detail/phone-block.vue').default);
Vue.component('phone-block-modal', require('./../components/roommate_ad/detail/phone-block-modal.vue').default);
Vue.component('ad-complaint', require('./../components/ad/ad-complaint/ad-complaint.vue').default);
Vue.component('verify-mobile-modal', require('./../components/modals/verify-mobile/verify-mobile.vue').default);
Vue.component('favorite-button', require('./../components/ad/favorite-button/favorite-button.vue').default);
Vue.component('static-action', require('./../components/roommate_ad/detail/static-action.vue').default);
Vue.component('need-credits-modal', require('./../components/credits/need-credits-modal.vue').default);
Vue.component('rating-number', require('./../components/rentals/rating-number.vue').default);

window.onload = function () {
	$('[data-toggle="tooltip"]').tooltip();

	EventBus.$emit('close-beacon', 'beacon');
};
